/** Shopify CDN: Minification failed

Line 19:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 20:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 22:2 Transforming let to the configured target environment ("es5") is not supported yet
Line 23:2 Transforming let to the configured target environment ("es5") is not supported yet
Line 35:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 61:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 69:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 70:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 107:46 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 140:6 Transforming const to the configured target environment ("es5") is not supported yet

**/
/**
 * Add subscriptions to cart
 */
function addSubscriptionsToCart() {
  const rechargeButtons = document.querySelectorAll('.subscription__btn');
  const addToCartButton = document.querySelectorAll('#add-to-cart-button');

  let selectedSellingPlanID = null;
  let selectedVariantID = null;

  if (!rechargeButtons) return;
  rechargeButtons.forEach(button => {
    // When page loads select the first button
    if (button.classList.contains('selected')) {
      selectedSellingPlanID = button.dataset.sellingPlanId;
      selectedVariantID = button.dataset.variantId;
    }

    // When button is clicked
    button.addEventListener('click', (e) => {
      const currentTarget = e.target;
      selectedSellingPlanID = currentTarget.dataset.sellingPlanId;
      selectedVariantID = currentTarget.dataset.variantId;

      // Remove selected class from all recharge buttons
      if (!currentTarget.classList.contains('selected')) {
        rechargeButtons.forEach(button => {
          button.classList.remove('selected');
        });
        // Add selected class to current recharge button
        currentTarget.classList.add('selected');
      }
    });
  });

  addToCartButton.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      addToCart(selectedSellingPlanID, selectedVariantID);
    });
  })

  /**
   * Add selected subscription to cart
   */
  function addToCart(sellingPlanID, variantID) {
    const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      
    submitButtons.forEach((submitButton) => {
      if (submitButton.classList.contains('loading')) return;
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
    });

    const form = document.querySelector('.product_form_id');
    let formData = new FormData(form);
    // append form data
    formData.append('id', variantID);
    formData.append('quantity', 1);
    formData.append('selling_plan', sellingPlanID);
    formData.append('sections', getSectionsToRender().map((section) => section.section));

    if (sellingPlanID && variantID) {
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        },
      })
      .then(response => response.json())
      .then(response => {
        renderContents(response);
      })
      .catch(error => {
        console.error('Error:', error);
      })
      .finally(() => {
        submitButtons.forEach((submitButton) => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
      });
    } else {
      console.error('Selling Plan ID or Variant ID is missing.');
    }
  }

  /**
   * Get section inner HTML
   */
  function getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  /**
   * Get sections to render
   */
  function getSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }

  /**
   *  Render contents
   */
  function renderContents(parsedState) {
    getSectionsToRender().forEach((section => {
      if (!document.getElementById(section.id)) return;
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);

      if (typeof CartDrawer !== 'undefined') {
        new CartDrawer();
      }
      if (typeof Cart !== 'undefined') {
        new Cart().renderContents(parsedState);
      }

      // opens cart
      document.getElementById('Cart-Drawer').classList.add('active');
      document.body.classList.add('open-cart');
      dispatchCustomEvent('cart-drawer:open');

      // close cart drawer when clicking outside cart card drawer
      if (!document.getElementById('Cart-Drawer')) {
        document.body.classList.remove('open-cc');
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }));
  }
}

addSubscriptionsToCart();